import React, { Component } from 'react';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { formatRoute } from 'react-router-named-routes';

import {
  Avatar,
  Hidden,
  Dialog,
  List,
  ListItem,
  ListItemText,
  Divider,
  MenuItem,
  Menu,
  IconButton,
  Typography,
  Toolbar,
  AppBar,
  Button,
} from '@material-ui/core';
import DashboardOutlined from '@material-ui/icons/DashboardOutlined';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import MenuOutlined from '@material-ui/icons/MenuOutlined';
import CloseIcon from '@material-ui/icons/Close';

import DashNav from '../../dashboard/components/DashNav';
import CommonNavItems from '../components/CommonNavItems';
import CommonMobileNavItems from '../components/CommonMobileNavItems';

import * as authActions from '../../auth/actions';
import * as constants from '../../config/constants';
import * as routes from '../../config/routes';
import classes from '../../css/getCSS';

import { getLogo } from '../../util';


class AuthNavbar extends Component {
  state = {
    anchorEl: null,
    mobileMenuOpen: false,
  }

  openDropMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  closeDropMenu = () => {
    this.setState({ anchorEl: null });
  };

  openMobileMenu = () => {
    this.setState({
      mobileMenuOpen: true,
    });
  }

  closeMobileMenu = () => {
    this.setState({
      mobileMenuOpen: false,
    });
  }

  logout = () => {
    this.props.logout(this.props.token);
  }

  render() {
    const logo = getLogo();

    const avatarUrl = constants.BASE_URL + this.props.user.avatar;

    const dropMenuOpen = Boolean(this.state.anchorEl);

    const dropMenu = (
      <Menu
        id="menu-appbar"
        anchorEl={this.state.anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={dropMenuOpen}
        onClose={this.closeDropMenu}
      >
        <MenuItem onClick={this.logout}>Logout</MenuItem>
      </Menu>
    );

    const navItems = (
      <React.Fragment>
        <CommonNavItems />
        <div
          role="presentation"
          className={classes.navAvatarWrapper}
          onClick={this.openDropMenu}
          onKeyPress={this.openDropMenu}
        >
          <Avatar
            alt={this.props.user.first_name}
            src={avatarUrl}
            className={classes.navAvatar}
          />
          <span className={classes.navName}>{this.props.user.first_name}</span>
          <span className="material-icons" style={{ color: '#777' }}>keyboard_arrow_down</span>
        </div>
        {dropMenu}
      </React.Fragment>
    );

    const fullName = `${this.props.user.first_name} ${this.props.user.last_name}`;

    const mobileDialog = (
      <Dialog
        fullScreen
        open={this.state.mobileMenuOpen}
        onClose={this.closeMobileMenu}
        classes={{
          paper: classes.dialogCard,
        }}
      >
        <AppBar style={{ position: 'relative' }}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.grow}>Menu</Typography>
            <IconButton color="inherit" onClick={this.closeMobileMenu} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Link
          to={formatRoute(routes.VIEW_PROFILE, { uuid: this.props.user.slug })}
          className={classes.linkDeCSS}
        >
          <List>
            <ListItem button>
              <Avatar alt={this.props.user.first_name} src={avatarUrl} />
              <ListItemText primary={fullName} />
            </ListItem>
          </List>
        </Link>
        <Divider />
        <DashNav
          user={this.props.user}
          dashActiveLink={this.props.dashActiveLink}
          closeDialog={this.closeMobileMenu}
        />
        <Divider />
        <List>
          <ListItem button onClick={this.logout}>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
        <Divider />
        <CommonMobileNavItems />
      </Dialog>
    );

    const subMenu = (
      <ul className={classes.subMenu}>
        <li className={this.props.activeLink === 'home' ? classes.active : null}><Link to="/"><DashboardOutlined /> <span>Home</span></Link></li>
        <li className={this.props.activeLink === 'search' ? classes.active : null}>
          <Link to={formatRoute(routes.SEARCH_FORM, { type: 'by-criteria' })}><SearchOutlined /> <span>Search</span></Link>
        </li>
        <Hidden mdUp>
          <li>
            <IconButton
              className={classes.iconMenuButton}
              onClick={this.openMobileMenu}
            >
              <MenuOutlined />
            </IconButton>
          </li>
        </Hidden>
      </ul>
    );

    let subMenuAppBar = null;

    if (!this.props.onlyLogout) {
      subMenuAppBar = (
        <AppBar position="static" color="primary" elevation={0} className={[classes.AuthNavbar, classes.subAppBar].join(' ')}>
          <Toolbar className={classes.subMenuToolbar}>
            <Link to="/" className={classes.linkDeCSS}>
              <img src={logo} alt="anjal" className={[classes.navLogo, classes.subNavLogo].join(' ')} />
            </Link>
            {subMenu}
          </Toolbar>
        </AppBar>
      );
    } else {
      subMenuAppBar = (
        <Hidden mdUp>
          <AppBar position="static" color="primary" elevation={0} className={[classes.AuthNavbar, classes.subAppBar].join(' ')}>
            <Toolbar className={classes.subMenuToolbar}>
              <Link to="/" className={classes.linkDeCSS}>
                <img src={logo} alt="anjal" className={[classes.navLogo, classes.subNavLogo].join(' ')} />
              </Link>
              <Button
                onClick={this.logout}
                style={{ color: '#fff' }}
              >
                Logout
              </Button>
            </Toolbar>
          </AppBar>
        </Hidden>
      );
    }

    const navbarWrapperStyle = {
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 1000,
    };

    const navbar = (
      <div style={navbarWrapperStyle}>
        <AppBar position="static" color="primary" elevation={0} className={[classes.AuthNavbar, classes.hiddenSM, classes.hiddenXS].join(' ')}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.grow}>
              <Link to="/" className={classes.linkDeCSS}>
                <img src={logo} alt="anjal" className={classes.navLogo} />
              </Link>
            </Typography>
            {navItems}
          </Toolbar>
        </AppBar>
        {subMenuAppBar}
        {mobileDialog}
      </div>
    );

    return navbar;
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: token => dispatch(authActions.logout(token)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthNavbar));



// WEBPACK FOOTER //
// ./src/common/containers/AuthNavbar.js